module.exports = {
	"LEADING_BID_MES": "You're the highest bidder",
	"NOT_LEADING_BID_MES": "Your bid is topped",
	"OBJECTS": "Objects",
	"PROCESSING_MES": "Processing",
	"VIDEO_PLAYER_MES": "Please note that the video feed can be delayed. The bids are updated in realtime.",
	"VIDEO_NOT_PLAYED_MES": "This device does not support video streaming. You can still make bids.",
	"NOT_LOGGED_IN_USER_MES": "You have to be logged in to be able to make bids.",
	"NEW_BID": "Make a new bid",
	"READ_MORE": "Read more...",
	"LESS": "Less...",
	"LAST_LOWER_BID_MES": "A similar bid has been given earlier by a third party. Please increase your bid to have the highest bid.",
	"START_PRICE": "Estimated Price",
	"HIGHEST_BID": "Highest bid",
	"WON_BID": "Your bid won",
	"HAMMER_PRICE": "Hammer price",
	"MES_WAITING_APPROVE": "Your bid is awaiting confirmation",
	"MES_BEFORE_AUCTION": "The picture is updated before the auction begins",
	"I_AGREE_WITH": "I accept the",
	"TERM": "terms",
	"CLOSE": "Close",
	"YOUR_BID": "Your bid",
	"Need help?": "Need help?"
};


/*****************
 ** WEBPACK FOOTER
 ** ../data/locale/en.json
 ** module id = 24
 ** module chunks = 0
 **/